import { render, staticRenderFns } from "./UserFooter.vue?vue&type=template&id=c9213406&"
import script from "./UserFooter.vue?vue&type=script&lang=ts&"
export * from "./UserFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports